import useListingFiltered from '../../hooks/useListingFiltered'

import Layout from '../Layout'
import FilterBar from '../FilterBar'
import ListingsGrid from '../ListingsGrid'
import SubmitHomeDialog from '../SubmitHomeDialog'

import type { Listing } from '../../services/getListings'
import type { IndividualListing } from '../../services/getListingById'

import type { CalculatorPageContent } from '../../hooks/useAcreCalculator'
import type { IBasicPageProps } from '../../pages/[slug]'

export type HomesInMarketProps = IBasicPageProps & {
  seoImage?: string
  calculator: CalculatorPageContent
} & {
  market: string
  listings: Array<Listing>
  listing?: IndividualListing
  fetchingListings?: boolean
}

export function HomesInMarket(props: HomesInMarketProps) {
  const listings = useListingFiltered(props.listings ?? [])

  return (
    <Layout
      subNavBar={<FilterBar />}
      nav={props.nav}
      footer={props.footer}
      centerMainContent={listings.length === 0}
      seoTitle={props.listing?.address ?? 'All Homes'}
      seoImage={props.seoImage}
      siteBanner={props.siteBanner}
      marketingBanner={props.marketingBanner}
    >
      <ListingsGrid
        listings={listings}
        fetching={props.fetchingListings}
        selectedHomeId={props.listing?.id}
        selectedHome={props.listing}
        calculator={props.calculator}
      />
      <SubmitHomeDialog />
    </Layout>
  )
}
